import React from 'react';
import Card from '../card/Card';
import P from '../texts/p/P';
import { BadgeStatus } from '../../utils/overdueColumns';

interface OverdueBadgeProps {
  status: BadgeStatus;
  size?: 'sm' | 'md';
}

const BADGE_CONFIG: Record<BadgeStatus, { label: string; bgColor: string; textColor: string }> = {
  PENDIENTE: {
    label: 'PENDIENTE',
    bgColor: '#AAB1BD',
    textColor: '#FFFFFF',
  },
  CANCELADO_ANTICIPADAMENTE: {
    label: 'CANCELADO ANTIC.',
    bgColor: '#3665B2',
    textColor: '#FFFFFF',
  },
  VENCIDA: {
    label: 'VENCIDA',
    bgColor: '#B45309',
    textColor: '#FFFFFF',
  },
  AFRONTADA: {
    label: 'AFRONTADA',
    bgColor: '#C2410C',
    textColor: '#FFFFFF',
  },
  HONRADA_PARCIAL: {
    label: 'HONRADA PARCIAL',
    bgColor: '#166534',
    textColor: '#FFFFFF',
  },
  HONRADA: {
    label: 'HONRADA',
    bgColor: '#166534',
    textColor: '#FFFFFF',
  },
  COBRADA_OK: {
    label: 'COBRADA OK',
    bgColor: '#E5E7EB',
    textColor: '#374151',
  },
  INCOBRABLE: {
    label: 'INCOBRABLE',
    bgColor: '#DC2626',
    textColor: '#FFFFFF',
  },
};

const OverdueBadge: React.FC<OverdueBadgeProps> = ({ status, size = 'sm' }) => {
  const config = BADGE_CONFIG[status] || BADGE_CONFIG.PENDIENTE;
  const padding = size === 'sm' ? '2px 8px' : '4px 12px';
  const keepOriginalCase = status === 'CANCELADO_ANTICIPADAMENTE';

  return (
    <Card
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      style={{
        backgroundColor: config.bgColor,
        borderRadius: '4px',
        padding,
        whiteSpace: 'nowrap',
        width: size === 'sm' ? '140px' : '160px',
        boxSizing: 'border-box',
      }}
    >
      <P
        type="3"
        withMargin={false}
        style={{
          color: config.textColor,
          fontSize: size === 'sm' ? '11px' : '13px',
          fontWeight: 700,
          textTransform: keepOriginalCase ? ('none' as const) : ('uppercase' as const),
          letterSpacing: '0.5px',
        }}
      >
        {config.label}
      </P>
    </Card>
  );
};

export default OverdueBadge;
